import http from './http'


export default {
    /**
     * Consulta los examenes
     * @returns {Promise}
     */
    all() {
        return http.get('examenes')
    },

    /**
     * Create a new examen
     * @param {Object} payload 
     * @returns {Promise}
     */
    add(payload) {
        return http.post('examenes', payload)
    },

    /**
     * Get an examen
     * @param {Object} examen 
     * @returns {Promise}
     */
    get(examen) {
        return http.get(`examenes/${examen}`)
    },

    /**
     * Update an examen
     * @param {int} examen 
     * @param {Object} payload 
     * @returns {Promise}
     */
    update(examen, payload) {
        return http.put(`examenes/${examen}`, payload)
    },

    /**
     * Activate an examen
     * @param {int} examen 
     * @returns {Promise}
     */
    activar(examen) {
        return http.put(`examenes/${examen}/activar`)
    },

    /**
     * Deactivate an examen
     * @param {int} examen 
     * @returns {Promise}
     */
    desactivar(examen) {
        return http.put(`examenes/${examen}/desactivar`)
    },
}